import MedicalExpenseTable from './MedicalExpenseTable'

export default MedicalExpenseTable
